import { inject, computed, unref } from 'vue';

export function useNodeAudience(id) {
  const nodeAudience = inject('nodeAudience', null);
  return computed(() => {
    if (!nodeAudience?.value) return null;
    const nodeId = unref(id);
    if (!nodeId) return null;
    const val = nodeAudience.value[nodeId];
    return val !== undefined ? val : null;
  });
}
